import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-navigation',
  imports: [CommonModule],
  templateUrl: './page-navigation.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageNavigation {
  @Input() page = 0;
  @Input() totalPages = 1;
  @Input() disabled = false;
  @Output() readonly pageChange = new EventEmitter<number>();

  get visiblePages(): Array<number | 'ellipsis'> {
    const total = Math.max(1, this.totalPages);
    if (total <= 7) return Array.from({ length: total }, (_, index) => index);

    const pages = new Set<number>([0, total - 1]);
    for (let index = this.page - 1; index <= this.page + 1; index++) {
      if (index > 0 && index < total - 1) pages.add(index);
    }

    const sortedPages = Array.from(pages).sort((a, b) => a - b);
    return sortedPages.flatMap((item, index) => {
      const previous = sortedPages[index - 1];
      return index > 0 && item - previous > 1 ? ['ellipsis' as const, item] : [item];
    });
  }
}
